export {default as Modal} from 'modal-react-native-web';
